import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "previewButton", "sendButton"]
  
  connect() {
    // Add event listener for form submission
    this.formTarget.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }
  
  disconnect() {
    // Clean up event listener
    this.formTarget.removeEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }
  
  handleSubmitEnd(event) {
    const response = event.detail.fetchResponse
    
    if (response.succeeded) {
      // Find the modal that contains this form and close it
      const modal = this.element.closest('dialog.modal')
      if (modal) {
        modal.close()
      }
      
      // Reset the form
      this.formTarget.reset()
    }
  }
  
  preview(event) {
    event.preventDefault()
    const formData = new FormData(this.formTarget)
    
    fetch('/time_reports/preview', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'text/html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        // Handle error response
        return response.json().then(error => {
          throw new Error(error.message || 'An error occurred')
        })
      }
      return response.text()
    })
    .then(html => {
      const previewModal = document.getElementById('preview_modal')
      previewModal.querySelector('.modal-body').innerHTML = html
      previewModal.showModal()
    })
    .catch(error => {
      // Show error message in a toast or alert
      this.showError(error.message)
    })
  }
  
  showError(message) {
    // Create a toast notification for the error
    const toast = document.createElement('div')
    toast.className = 'toast toast-center'
    toast.innerHTML = `
      <div class="alert alert-error">
        <iconify-icon icon="ph:warning" class="w-5 h-5"></iconify-icon>
        <span>${message}</span>
      </div>
    `
    
    document.body.appendChild(toast)
    
    // Remove the toast after 3 seconds
    setTimeout(() => {
      toast.remove()
    }, 3000)
  }
} 